// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__68HTq","tabsBox":"styles_tabsBox__2Jc4o","createButton":"styles_createButton__1evJ8"};